import { memo } from "react";

// components
import { Stack, Divider } from "@mui/material";

// styled
import styled from "styled-components";

const SidebarStepSelectProductCategory = ({ 
  categories = [], 
  selectProductCategory = () => { },
}) => (
  <Stack
    divider={<Divider flexItem />}
    spacing={1}
    height="100%"
    width="100%"
    justifyContent="space-evenly"
    alignItems="center"
    bgcolor="transparent"
  >
    {categories.map(({ sync_id: id, name }) => (
      <Stack
        as={ProductCategory}
        key={id}
        direction="row"
        onClick={selectProductCategory.bind(null, id)}
      >
        <h2>{name}</h2>
      </Stack>
    ))}
  </Stack>
);

const ProductCategory = styled.button`
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 45px;
    cursor: pointer;
    background-color: transparent;
`;

export default memo(SidebarStepSelectProductCategory);
